var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var KeldaError = /** @class */ (function (_super) {
    __extends(KeldaError, _super);
    function KeldaError(message) {
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = 'KeldaError';
        return _this;
    }
    return KeldaError;
}(Error));
export default KeldaError;
